import { TZDate } from '@date-fns/tz';
import { useRef } from 'react';

import { formatDate } from '@dynatrace-sdk/units';

import { calendarFieldCSS } from './Calendar.sty.js';
import { CalendarItem } from './CalendarItem.js';
import { useMonth } from './hooks/useMonth.js';
import { useFormFieldContext } from '../forms-core/hooks/useFormFieldContext.js';

export const Month = ({ date }: { date: TZDate }) => {
  // Reference of the month button, needed to pass to the hook for proper focus management
  const itemRef = useRef<HTMLDivElement>(null);

  const { ariaLabel, tabIndex, isSelected, isCurrent, onClick, isDisabled } =
    useMonth({
      date,
      itemRef,
    });
  const { disabled, ariaDisabled } = useFormFieldContext();
  const highlightColor = isSelected ? 'primary' : 'neutral';

  return (
    <td
      className={calendarFieldCSS({
        color: highlightColor,
        isDisabled: isDisabled || disabled || ariaDisabled,
      })}
      role="presentation"
    >
      <CalendarItem
        ref={itemRef}
        className="calendar-button calendar-body-button"
        isCurrent={isCurrent}
        isSelected={isSelected}
        isDisabled={isDisabled || disabled}
        highlightColor={highlightColor}
        tabIndex={tabIndex}
        role="gridcell"
        aria-selected={!!isSelected}
        ariaLabel={ariaLabel}
        view="month"
        onClick={onClick}
      >
        {formatDate(date, {
          month: 'short',
        })}
      </CalendarItem>
    </td>
  );
};
Month['displayName'] = 'Month';
